const scopes = {
    create: ['campaign', 'offer', 'drawing', 'drawingResult', 'reward', 'message'],
    read: ['campaign', 'offer', 'drawing', 'reward', 'message','template'],
    update: ['campaign', 'offer', 'drawing'],
    delete: ['campaign', 'offer']
}

export function getScope() {
    var scope = '';
    var keys = Object.keys(scopes);
    keys.map(x => {
        scopes[x].map(y => {
            scope += `${x}:${y} `;
        })
    })
    return scope;
}